function NotFound() {
  return (
    <div className="h-screen w-full flex items-center justify-center">
      <h1 className="text-3xl">404</h1>
    </div>
  );
}

export default NotFound;
